import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {
  mixinFlexboxColumn,
  mixinFloatingSideBar,
  mixinOverflowY,
  mixinTruncate,
} from 'webapp-lib/styling';

const mixinNamesAndIcon = css`
  display: flex;
  justify-content: space-between;
  gap: var(--gutter);
`;

const mixinUploadQueueItem = css`
  padding: var(--gutter-small) var(--focus-border-width);
  font-weight: var(--font-weight-thin);
  width: 100%;

  :not(:last-of-type) {
    border-bottom: var(--regular-border-width) solid var(--color-box-border);
  }
`;

export const UploadQueueFileName = styled.span`
  display: block;
  font-size: var(--font-size-default);
  ${mixinTruncate}

  padding: var(--focus-border-width);

  a {
    color: var(--color-core-link);
    text-decoration: none;
  }
`;

export const UploadQueueItemCasus = styled.span`
  display: block;
  color: var(--color-core-dark-grey);
  font-size: var(--font-size-small);
  margin-bottom: var(--gutter-tiny);

  ${mixinTruncate}
`;

export const UploadQueueItem = styled.li`
  ${mixinNamesAndIcon}
  ${mixinUploadQueueItem}
`;

export const PendingUploadQueueItem = styled.li`
  ${mixinUploadQueueItem}

  & > div {
    ${mixinNamesAndIcon}
  }
`;

export const CasusAndFileNameWrapper = styled.div`
  min-width: 0;
`;

export const StyledUploadQueue = styled.ul`
  padding-left: unset;
  list-style: none;
  margin: 0;
  ${mixinOverflowY};
`;

export const UploadQueueSideBar = styled.div`
  ${mixinFloatingSideBar}
  padding: var(--gutter);

  ${mixinFlexboxColumn}

  .SubTabBar {
    margin-bottom: var(--gutter-small);
  }
`;

export const AllItemsActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--gutter-little);
`;
